<template>
  <div class="content" style="height: 790px">
    <card title="参观" v-if="1 == 2">
      <div class="card_chaijie box_style">
        <div class="view_box">
          <div class="xg_flv" id="xgFlvVisit"></div>
        </div>
      </div>
    </card>
    <card title="发电工艺" styles="margin-top:24px" v-if="1 == 2">
      <div class="card_chaijie box_style">
        <div class="view_box">
          <video-streaming
            v-if="1 == 2"
            url="http://172.30.100.201/subapp/huoshan-gis-platform/static/img/3.cbaa0b57.jpg"
          />
          <img
            src="http://172.30.100.201/subapp/huoshan-gis-platform/static/img/2.20ed85c7.jpg"
            alt=""
            class="Img"
            style="width: 100%; height: 100%"
          />
        </div>
        <p class="info">
          水流经由压力引水管、水轮机、发电机和尾水管等，电能经发电机、断路器、升压变接入电网的过程示意。水流经由压力引水管、水轮机、发电机和尾水管等，电能经发电机、断路器、升压变接入电网的过程示意。
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import VideoStreaming from '@/components/Streaming/index.vue';
import Player from 'xgplayer';
export default {
  components: {
    Card,
    VideoStreaming,
  },
  data() {
    return {};
  },
  mounted() {
    var player = new Player({
      id: 'xgFlvVisit',
      url: 'http://172.30.100.201:8000/prd200000/upload/20231020/5e46228e95f6d297dfb1b2e294131eee.mp4',
      playsinline: true,
      poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/1.a78d9ebb.jpg',
      autoplay: true,
      width: 462,
      height: 257,
      plugins: [],
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.card_chaijie {
}
</style>
